import React from 'react'

const STYLE = {
  position: 'fixed',
  zIndex: 3,
  top: 0,
  left: 0,
  right: 0,
  height: 20,
  WebkitAppRegion: 'drag', // Electron drag zone
}

export default function DesktopTitleBar() {
  return <div style={STYLE} />
}
